export default "__VITE_ASSET__B$atTLqp__"